import { PaymentType } from "../../../common/enums/PaymentMethods";
import { PaymentMethod } from "../../../types/reservation";

export function usePaymentMethods(
  paymentMethods: PaymentMethod[],
  total: number,
  isInvoice = false,
) {
  const payNowMethod = paymentMethods.find((m) => m.type === PaymentType.Smart);
  const apiMethod = paymentMethods.find((m) => m.type === PaymentType.Api);
  const payLaterMethod = paymentMethods.find((m) => m.type === PaymentType.Cash);
  const irisMethod = paymentMethods.find((m) => m.type === PaymentType.Iris);

  const isPayNowActive = !!(payNowMethod?.active || apiMethod?.active);
  const hasSecondaryPaymentOptions =
    total !== 0 && !isInvoice && !!(payLaterMethod?.active || irisMethod?.active);

  return {
    payNowMethod,
    apiMethod,
    payLaterMethod,
    irisMethod,
    isPayNowActive,
    hasSecondaryPaymentOptions,
  };
}